export default {
  headers: [
    {
      text: 'ID',
      value: 'id',
    },
    {
      text: 'Project',
      value: 'project',
    },
    {
      text: 'Expense Code',
      value: 'expenseCode',
    },
    {
      text: 'Date',
      value: 'date',
    },
    {
      text: 'Hours Spent',
      value: 'hoursSpent',
    },
    {
      text: 'Status',
      value: 'status',
    },
    {
      text: 'Actions',
      value: 'actions',
      sort: false,
    },
  ],
  options: {
    loadingText: 'Loading timesheet... Please wait',
    showSelect: true,
    itemsPerPage: 10,
  },
  bulkActionItems: [{
    title: 'Delete selected',
    id: 'deleteAll',
    action: 'onMulitpleDelete',
  }],
};
